module.exports = __webpack_public_path__ + "img/img-funcionalidades-medida.a6a6990a.webp";